const BRAND = "#143887";

export default function VehicleIcons({vehicleType}: {vehicleType: string}) {
    // Bike
    if (vehicleType?.includes("bike")) {
        return (
            <svg width="120" height="70" viewBox="0 0 64 64" fill="none">
                <circle cx="18" cy="48" r="10" stroke={BRAND} strokeWidth="2" />
                <circle cx="48" cy="48" r="10" stroke={BRAND} strokeWidth="2" />
                <path
                d="M18 48L28 30H38L48 48M28 30L22 20M38 30L44 20"
                stroke={BRAND}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                />
            </svg>
        );
    }

    // Van
    if (vehicleType?.includes("van")) {
        return (
            <svg width="130" height="70" viewBox="0 0 64 64" fill="none">
                <rect x="8" y="24" width="32" height="18" rx="3" stroke={BRAND} strokeWidth="2" />
                <path
                d="M40 30H50L56 38V42H40V30Z"
                stroke={BRAND}
                strokeWidth="2"
                strokeLinejoin="round"
                />
                <circle cx="20" cy="46" r="5" stroke={BRAND} strokeWidth="2" />
                <circle cx="46" cy="46" r="5" stroke={BRAND} strokeWidth="2" />
            </svg>
        );
    }

    // Lorry / Truck
    if (vehicleType?.includes("lorry") || vehicleType?.includes("truck")) {
        return (
            <svg width="140" height="75" viewBox="0 0 64 64" fill="none">
                <rect x="6" y="22" width="30" height="20" rx="2" stroke={BRAND} strokeWidth="2" />
                <path
                d="M36 28H48L56 36V42H36V28Z"
                stroke={BRAND}
                strokeWidth="2"
                strokeLinejoin="round"
                />
                <circle cx="18" cy="46" r="5" stroke={BRAND} strokeWidth="2" />
                <circle cx="44" cy="46" r="5" stroke={BRAND} strokeWidth="2" />
            </svg>
        );
    }

    // Default Car
    return (
            <svg width="130" height="70" viewBox="0 0 64 64" fill="none">
            <path
                d="M10 38L16 26H44L52 38"
                stroke={BRAND}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <rect x="10" y="38" width="42" height="10" rx="2" stroke={BRAND} strokeWidth="2" />
            <circle cx="20" cy="50" r="5" stroke={BRAND} strokeWidth="2" />
            <circle cx="42" cy="50" r="5" stroke={BRAND} strokeWidth="2" />
            </svg>
    );

}